<!--floorData2
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 11:12:37
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div style="width: 100%; height: 100%; display: flex; flex-direction: column">
    <div class="header">
      <div class="header-left">
        <ul>
          <li v-for="(item, index) in tabList" :key="index" :class="item.code == active ? 'on' : ''" @click="showContent(item.code)">
            <img :src="item.icon" alt="" />
            <span>{{ item.text }}</span>
          </li>
        </ul>
      </div>
      <div class="header-right">
        <div class="hearder-btn" v-if="active === 1" @click="saveData">提交</div>
      </div>
    </div>
    <div class="main">
      <!-- 体征记录 -->
      <div v-show="active == 1" class="content" ref="mainDiv" style="background-color: #fff; height: 100%">
        <div class="content-left" v-show="filtrateBox">
          <div>
            <div class="filtrate-close" :style="{ top: isApp ? '1.8rem' : '2.8rem' }" @click="filtrateBox = false">
              <span>收缩</span>
            </div>
          </div>
          <div class="filtrate-content">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="楼栋" name="2">
                <div class="filtrate-list">
                  <div :class="isCheckDistrict2(item.Name)" class="filtrate-item" v-for="(item, index) in district2" :key="index" @click="BuildingAreas2(0, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="楼层" name="3">
                <div class="filtrate-list">
                  <div :class="isCheckFloor2(item.Name)" class="filtrate-item" v-for="(item, index) in floorList2" :key="index" @click="BuildingAreas2(1, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="房间" name="4">
                <div class="filtrate-list">
                  <div :class="allroom2 ? 'on' : ''" class="filtrate-item" @click="allRooms2">全选</div>
                </div>
                <div class="filtrate-list">
                  <div :class="isCheckRoom2(item.Name)" class="filtrate-item" v-for="(item, index) in roomList2" :key="index" @click="BuildingAreas2(2, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="记录" name="5">
                <div class="filtrate-list">
                  <div :class="allrecord ? 'on' : ''" class="filtrate-item" @click="allRecord">全选</div>
                </div>
                <div class="filtrate-list">
                  <div :class="isCheckRecord(item.Name)" class="filtrate-item" v-for="(item, index) in recordList" :key="index" @click="BuildingAreas2(3, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="content-right-box" :style="filtrateBox ? 'left:5rem' : ''">
          <div class="content-right">
            <div class="top" style="display: flex">
              <div class="filtrate" @click="filtrateBox = true" v-show="filtrateBox == false">
                <span>筛选</span>
              </div>

              <div class="entire" style="position: absolute; right: 0">
                <div class="entire-affirm" @click="searchHistory">生成</div>
              </div>
            </div>
            <div class="table-content">
              <el-table :data="historyData.slice((currentPage2 - 1) * pagesize2, currentPage2 * pagesize2)" header-row-class-name="table-header" height="100%">
                <el-table-column label="信息" min-width="20%">
                  <template slot-scope="scope">
                    <div class="history-message">
                      <div class="user-message" style="flex: 1">
                        <span style="margin-left: 0">{{ scope.row.ProfileName }}</span>
                        <span v-if="scope.row.RoomNo" class="last">{{ scope.row.RoomNo }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="记录" min-width="15%">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.Message }}
                    </div>
                  </template>
                </el-table-column>
                <!--<el-table-column label="数值/单位/时间" min-width="50%">
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.Value" class="add-unit">
                                                <div><span>{{scope.row.Value}}{{scope.row.Unit}}</span><img @click="showFinish(scope.row,'edit')" src="/images/iPadNew/edit.png"/></div>
                                                <p>{{scope.row.CDate}}</p>
                                            </div>
                                            <div v-else class="add-sign" @click="showFinish(scope.row,'add')">
                                                <img src="/images/iPadNew/add.png">
                                                <span>添加</span>
                                            </div>

                                        </template>
                                    </el-table-column>-->
                <el-table-column label="数值/单位" min-width="52%">
                  <template slot-scope="scope">
                    <div class="add-unit">
                      <div style="margin-bottom: 0"><el-input v-model="scope.row.Value" placeholder="请输入内容" style="width: 85%" @blur="handleInput(scope.row)"></el-input>{{ scope.row.Unit }}</div>
                    </div>
                    <div class="add-unit">
                      <div style="margin-bottom: 0; width: 100%">
                        <el-date-picker
                          v-model="scope.row.CDate"
                          type="datetime"
                          placeholder="选择日期时间"
                          style="width: 100%; font-size: 13px"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm"
                        ></el-date-picker>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <!--
                                    <el-table-column label="操作" min-width="10%">
                                        <template slot-scope="scope">
                                            <div class="status-btn">
                                                <div @click="showExplain(scope.row)" v-if="scope.row.IsCheck == false">
                                                    <img :src="scope.row.Remark?'/images/iPadNew/icon33.png':'/images/iPadNew/icon34.png'"
                                                         alt="">
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                     -->
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                background
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="currentPage2"
                :page-sizes="[20, 50, 100, 150]"
                :page-size="20"
                layout="total, sizes, prev, pager, next"
                :total="historyData.length"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- 历史记录 -->
      <div v-show="active == 2" class="content" ref="mainDiv1" style="background-color: #fff; height: 100%">
        <div class="content-left" v-show="filtrateBox">
          <div class="filtrate-close" :style="{ top: isApp ? '1.8rem' : '2.8rem' }" @click="filtrateBox = false">
            <span>收缩</span>
          </div>
          <div class="filtrate-content">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="楼栋" name="2">
                <div class="filtrate-list">
                  <div :class="isCheckDistrict3(item.Name)" class="filtrate-item" v-for="item in district3" @click="BuildingAreas3(0, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="楼层" name="3">
                <div class="filtrate-list">
                  <div :class="isCheckFloor3(item.Name)" class="filtrate-item" v-for="item in floorList3" @click="BuildingAreas3(1, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="房间" name="4">
                <div class="filtrate-list">
                  <div :class="allroom3 ? 'on' : ''" class="filtrate-item" @click="allRooms3">全选</div>
                </div>
                <div class="filtrate-list">
                  <div :class="isCheckRoom3(item.Name)" class="filtrate-item" v-for="item in roomList3" @click="BuildingAreas3(2, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="记录" name="5">
                <div class="filtrate-list">
                  <div :class="allrecord3 ? 'on' : ''" class="filtrate-item" @click="allRecord3">全选</div>
                </div>
                <div class="filtrate-list">
                  <div :class="isCheckRecord3(item.Name)" class="filtrate-item" v-for="item in recordList3" @click="BuildingAreas3(3, item)">{{ item.Name }}</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="content-right-box" :style="filtrateBox ? 'left:1rem' : ''">
          <div class="content-right">
            <div class="top" style="display: flex; height: 1rem">
              <div class="filtrate" @click="filtrateBox = true" v-show="filtrateBox == false">
                <span>筛选</span>
              </div>
              <div class="entire" style="position: absolute; right: 0">
                <div class="entire-affirm" @click="searchHistoryList">搜索</div>
              </div>
            </div>

            <div class="top" style="display: flex; height: 1.5rem">
              <div class="historyData">
                <el-date-picker v-model="begin" type="date" placeholder="开始日期" style="width: 160px" value-format="yyyy-MM-dd" :editable="false"> </el-date-picker>
                <span style="font-size: 16px">至</span>
                <el-date-picker v-model="end" type="date" style="width: 160px" placeholder="结束日期" value-format="yyyy-MM-dd" :editable="false"> </el-date-picker>
              </div>
            </div>
            <div class="table-content" ref="mainDiv2" style="height: calc(100% - 4.2rem)">
              <el-table :data="historyList.slice((currentPage3 - 1) * pagesize3, currentPage3 * pagesize3)" header-row-class-name="table-header" height="100%">
                <el-table-column label="信息" min-width="30%">
                  <template slot-scope="scope">
                    <div class="history-message">
                      <div class="user-message" style="flex: 1">
                        <span style="margin-left: 0">{{ scope.row.ProfileName }}</span>
                        <span v-if="scope.row.RoomNo" class="last">{{ scope.row.RoomNo }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="记录" min-width="20%">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.Label }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="数值/单位/时间" min-width="50%">
                  <template slot-scope="scope">
                    <div class="add-unit">
                      <div>
                        <span>{{ scope.row.Value }}{{ scope.row.Unit }}</span>
                      </div>
                      <p>{{ scope.row.CDate | dateFormat('yyyy-mm-dd h:m') }}</p>
                      <p>{{ scope.row.Remark }}</p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                background
                @size-change="handleSizeChange3"
                @current-change="handleCurrentChange3"
                :current-page="currentPage3"
                :page-sizes="[20, 50, 100, 150]"
                :page-size="20"
                layout="total, sizes, prev, pager, next"
                :total="historyList.length"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nvaLeft from '@/assets/imgs/left@2x (2).png'
export default {
  // 组件状态值
  data() {
    return {
      isApp: true,
      nvaLeft,
      timeData: [],
      UserName: '',
      loading: true,
      details: [], //老人详情
      obj: {},
      begin: this.dateFormats(false), // 历史选择日期
      end: this.dateFormats(false),
      date: this.dateFormats(true),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      historyData: [], //体征记录
      historyList: [], //历史记录
      dialogTableVisible: false, //历史数据弹窗显示隐藏
      drawer: false, //右侧功能列表显示隐藏
      tabList: [
        {
          icon: '/images/iPadNew/fuyaojihua.png',
          text: '体征记录',
          code: 1
        },
        {
          icon: '/images/iPadNew/lishijilu.png',
          text: '历史记录',
          code: 2
        }
      ], //头部菜单
      active: 1, //控制头部菜单选中
      searchText: '', //搜索内容
      items: {},
      dialogExplain: false, //添加说明弹窗
      dialogUnfinished: false, //未完成时弹窗
      status: 4,
      detailsItem: {}, //单个老人详情
      filtrateBox: false, // 过滤器
      dialogFinished: false, //完成时弹窗
      input: '', //输入数值
      activeNames: [],
      filtrate: {}, //筛选数据
      filterCopy: {},
      generaData2: [],
      allProject2: [], //全部项目小类
      districtData2: [],
      floorData2: [], //楼层数据
      roomData2: [], //房间数据
      recordData: [], //记录数据
      llist2: [], //已选楼栋
      clist2: [], //已选楼层
      croom2: [], //选中的房间
      cbig2: [], //已选大类
      csmall2: [], //已选小类
      crecord: [], //已选记录

      generaData3: [],
      allProject3: [], //全部项目小类
      districtData2: [],
      floorData3: [], //楼层数据
      roomData3: [], //房间数据
      recordData3: [], //记录数据
      llist3: [], //已选楼栋
      clist3: [], //已选楼层
      croom3: [], //选中的房间
      cbig3: [], //已选大类
      csmall3: [], //已选小类
      crecord3: [], //已选记录
      timeList2: [
        {
          name: '早班',
          beginTime: '06:30',
          endTime: '14:30',
          checked: false
        },
        {
          name: '中班',
          beginTime: '14:30',
          endTime: '22:30',
          checked: false
        },
        {
          name: '晚班',
          beginTime: '22:30',
          endTime: '06:30',
          checked: false
        }
      ],
      pagesize2: 20,
      currentPage2: 1,
      pagesize3: 20,
      currentPage3: 1,
      allrecord: false,
      allroom2: false,
      allbig2: false,
      allsmall2: false,
      allrecord3: false,
      allroom3: false,
      allbig3: false,
      allsmall3: false,
      loadings: false,
      loadings1: false,
      showBtn: false
    }
  },

  created() {
    this.isApp = localStorage.getItem('isApp') === '0'
    //console.log("-----------------------")
    var token = JSON.parse(localStorage.getItem('user'))
    //console.log(token);
    if (token) {
      this.UserName = token.UserName
      this.searchData(token.UserId)
    }

    if (localStorage.getItem('lifeRecord')) {
      this.$confirm('是否提交上次未保存的体记录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var member = JSON.parse(localStorage.getItem('user'))
          const objs = JSON.parse(localStorage.getItem('lifeRecord'))
          this.$axios.post('/Pad/SaveVitalSigns?cUser=' + member.UserName + '&cUserId=' + member.UserId, objs).then((response) => {
            if (response.data.ok) {
              this.$message({
                message: '提交成功',
                offset: 100,
                type: 'success'
              })
            } else {
              thgis.$message.error({
                message: response.data.msg || '出错了，请稍后重试',
                offset: 100
              })
            }
            localStorage.removeItem('lifeRecord')
          }),
            (err) => {
              localStorage.removeItem('lifeRecord')
            }
        })
        .catch(() => {
          localStorage.removeItem('lifeRecord')
        })
    }
  },
  filters: {
    dateFormat: function (dateStr, pattern = '') {
      var dt = new Date(dateStr)
      var yy = dt.getFullYear()
      var mm = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1
      var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds()
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return yy + '-' + mm + '-' + dd
      } else if (pattern.toLowerCase() === 'mm-dd h:m') {
        return mm + '-' + dd + ' ' + h + ':' + m
      } else if (pattern.toLowerCase() === 'yyyy.mm.dd') {
        return yy + '.' + mm + '.' + dd
      } else {
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
      }
    },
    substring: function (val) {
      if (val.length == 0 || val == null || val == undefined) {
        return
      } else {
        return val.substring(0, 16)
      }
    }
  },
  watch: {
    llist2: function () {
      var that = this
      this.clist2 = this.clist2.filter((item) => {
        return that.floorNames2.indexOf(item) > -1
      })
    },
    clist2: function () {
      var that = this
      this.croom2 = this.croom2.filter((item) => {
        return that.roomNames2.indexOf(item) > -1
      })
    },
    cbig2: function () {
      var that = this
      this.csmall2 = this.csmall2.filter((item) => {
        return that.projectName2.indexOf(item) > -1
      })
    },
    llist3: function () {
      var that = this
      this.clist3 = this.clist3.filter((item) => {
        return that.floorNames3.indexOf(item) > -1
      })
    },
    clist3: function () {
      var that = this
      this.croom3 = this.croom3.filter((item) => {
        return that.roomNames3.indexOf(item) > -1
      })
    },
    cbig3: function () {
      var that = this
      this.csmall3 = this.csmall3.filter((item) => {
        return that.projectName3.indexOf(item) > -1
      })
    }
  },
  computed: {
    //区域
    district2: function () {
      var list = this.districtData2
      return list
    },
    //楼层
    floorList2: function () {
      var list = this.floorData2
      if (this.llist2.length == 0) {
        return list
      }
      return (list = list.filter((item) => {
        return this.llist2.indexOf(item.parent) > -1
      }))
    },
    // 房间
    roomList2: function () {
      var list = this.roomData2
      if (this.llist2.length > 0) {
        list = list.filter((item) => {
          return this.llist2.indexOf(item.parent) > -1
        })
      }
      if (this.clist2.length > 0) {
        list = list.filter((item) => {
          return this.clist2.indexOf(item.parent1) > -1
        })
      }
      return list
    },
    //项目大类
    genera2: function () {
      var list = this.generaData2
      return list
    },
    // 项目小类
    smallProject2: function () {
      var list = this.allProject2
      if (this.cbig2.length == 0) {
        return list
      } else {
        return (list = list.filter((item) => {
          return this.cbig2.indexOf(item.parent) > -1
        }))
      }
    },
    recordList: function () {
      var list = this.recordData
      return list
    },
    isCheckRecord: function () {
      return function (roomName) {
        return {
          on: this.crecord.indexOf(roomName) > -1
        }
      }
    },
    // 房间选中
    isCheckRoom2: function () {
      return function (roomName) {
        return {
          on: this.croom2.indexOf(roomName) > -1
        }
      }
    },
    // 楼层选中
    isCheckFloor2: function () {
      return function (roomName) {
        return {
          on: this.clist2.indexOf(roomName) > -1
        }
      }
    },
    // 区域选中
    isCheckDistrict2: function () {
      return function (roomName) {
        return {
          on: this.llist2.indexOf(roomName) > -1
        }
      }
    },
    // 过滤选中楼层名字
    floorNames2: function () {
      return this.floorList2.map((item) => {
        return item.Name
      })
    },
    // 过滤选中房间名字
    roomNames2: function () {
      return this.roomList2.map((item) => {
        return item.Name
      })
    },
    projectName2() {
      return this.smallProject2.map((item) => {
        return item.Name
      })
    },
    isCheckGenera2: function () {
      return function (roomName) {
        return {
          on: this.cbig2.indexOf(roomName) > -1
        }
      }
    },
    isCheckProject2: function () {
      return function (roomName) {
        return {
          on: this.csmall2.indexOf(roomName) > -1
        }
      }
    },
    //区域
    district3: function () {
      var list = this.districtData3
      return list
    },
    //楼层
    floorList3: function () {
      var list = this.floorData3
      if (this.llist3.length == 0) {
        return list
      }
      return (list = list.filter((item) => {
        return this.llist3.indexOf(item.parent) > -1
      }))
    },
    // 房间
    roomList3: function () {
      var list = this.roomData3
      if (this.llist3.length > 0) {
        list = list.filter((item) => {
          return this.llist3.indexOf(item.parent) > -1
        })
      }
      if (this.clist3.length > 0) {
        list = list.filter((item) => {
          return this.clist3.indexOf(item.parent1) > -1
        })
      }
      return list
    },
    //项目大类
    genera3: function () {
      var list = this.generaData3
      return list
    },
    // 项目小类
    smallProject3: function () {
      var list = this.allProject3
      if (this.cbig3.length == 0) {
        return list
      } else {
        return (list = list.filter((item) => {
          return this.cbig3.indexOf(item.parent) > -1
        }))
      }
    },
    recordList3: function () {
      var list = this.recordData3
      return list
    },
    isCheckRecord3: function () {
      return function (roomName) {
        return {
          on: this.crecord3.indexOf(roomName) > -1
        }
      }
    },
    // 房间选中
    isCheckRoom3: function () {
      return function (roomName) {
        return {
          on: this.croom3.indexOf(roomName) > -1
        }
      }
    },
    // 楼层选中
    isCheckFloor3: function () {
      return function (roomName) {
        return {
          on: this.clist3.indexOf(roomName) > -1
        }
      }
    },
    // 区域选中
    isCheckDistrict3: function () {
      return function (roomName) {
        return {
          on: this.llist3.indexOf(roomName) > -1
        }
      }
    },
    // 过滤选中楼层名字
    floorNames3: function () {
      return this.floorList3.map((item) => {
        return item.Name
      })
    },
    // 过滤选中房间名字
    roomNames3: function () {
      return this.roomList3.map((item) => {
        return item.Name
      })
    },
    projectName3() {
      return this.smallProject3.map((item) => {
        return item.Name
      })
    },
    isCheckGenera3: function () {
      return function (roomName) {
        return {
          on: this.cbig3.indexOf(roomName) > -1
        }
      }
    },
    isCheckProject3: function () {
      return function (roomName) {
        return {
          on: this.csmall3.indexOf(roomName) > -1
        }
      }
    }
  },
  beforeMount: function () {},
  mounted() {
    let that = this
    window.onbeforeunload = function (e) {
      if (window.location.href == window.location.href) {
        // 注意这里要替换成自己的当前页面的路由
        let obj = JSON.stringify(that.obj)
        // 页面刷新时保持数据   加载时更新
        sessionStorage.setItem('item', obj)
        e = e || window.event
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = '关闭提示'
        }
        return '关闭提示'
      } else {
        window.onbeforeunload = null
      }
    }
    this.getPassYearFormatDate()
    this.getDivHeight()
    window.addEventListener('resize', this.getDivHeight)
  },
  methods: {
    getDivHeight() {
      const screenheight = window.innerHeight
      this.$refs.mainDiv.style.height = screenheight - 150 + 'px'
      this.$refs.mainDiv1.style.height = screenheight - 150 + 'px'
      this.$refs.mainDiv2.style.height = screenheight - 337 + 'px'

      // 704 为 头部组件高度 + 底部组件高度
      // mainDiv 为需控制高度自适应盒子，通过 ref="mainDiv" 绑定
    },
    // 交班信息默认选中一个月的日期
    getPassYearFormatDate() {
      var nowDate = new Date()
      var date = new Date(nowDate)
      date.setDate(date.getDate() - 30)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var formatDate = year + seperator1 + month + seperator1 + strDate
      this.getNowFormatDate(formatDate)
    },
    /* 获取现在时间，并接受过去时间的值 */
    getNowFormatDate(formatDate) {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var nowData = year + seperator1 + month + seperator1 + strDate
      this.timeData = [formatDate, nowData] // 默认赋值一年时间
    },
    // 初始化选择时间 默认当天
    dateFormats: function (time) {
      var dt = new Date()
      var yy = dt.getFullYear()
      var mm = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1
      var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds()
      if (time) {
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
      } else {
        return yy + '-' + mm + '-' + dd
      }
    },

    handleSizeChange2(val) {
      this.pagesize2 = val
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
    },
    handleSizeChange3(val) {
      this.pagesize3 = val
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val
    },

    // 筛选数据
    searchData(userId) {
      this.$axios.post('/Pad/FilterQuery?userId=' + userId).then((response) => {
        if (response.data.ok) {
          this.filtrate = response.data.obj
          this.filterCopy = response.data.obj
          this.arrList()
        } else {
          this.$message.error({
            message: response.msg,
            offset: 100
          })
        }
      }),
        (err) => {
          return false
        }
    },
    arrList() {
      // 历史记录筛选数据
      var arr = []
      // 遍历项目大类中的小类
      this.filtrate.ProjectCategories.forEach((item) => {
        arr.push({
          Name: item.Name,
          checked: false,
          parent: item.Name,
          child: item.Items
        })
      })
      this.generaData2 = arr
      var arr4 = []
      this.generaData2.forEach((item) => {
        item.child.forEach((ite) => {
          arr4.push({
            Name: ite.Name,
            parent: item.Name,
            checked: false
          })
        })
      })
      this.allProject2 = arr4
      var arr3 = []
      // 遍历项目楼栋中的小类
      this.filtrate.BuildingAreas.forEach((item) => {
        arr3.push({
          Name: item.Name,
          checked: false,
          parent: item.Name,
          child: item.Floors
        })
      })
      this.districtData2 = arr3
      var arr1 = []
      // 遍历项目楼栋中的小类
      this.districtData2.forEach((item) => {
        item.child.forEach((ite) => {
          arr1.push({
            Name: ite.Name,
            parent: item.Name,
            child: ite.Rooms,
            checked: false
          })
        })
      })
      this.floorData2 = arr1
      var arr2 = []
      // 遍历项目楼栋中的小类
      this.floorData2.forEach((item) => {
        item.child.forEach((ite) => {
          arr2.push({
            parent: item.parent,
            Name: ite,
            parent1: item.Name,
            checked: false
          })
        })
      })
      this.roomData2 = arr2
      var arr3 = []
      // 遍历项目楼栋中的小类
      this.filtrate.Records.forEach((item) => {
        arr3.push({
          parent: item,
          Name: item,
          checked: false
        })
      })
      this.recordData = arr3

      // 历史记录筛选数据
      var arr = []
      // 遍历项目大类中的小类
      this.filtrate.ProjectCategories.forEach((item) => {
        arr.push({
          Name: item.Name,
          checked: false,
          parent: item.Name,
          child: item.Items
        })
      })
      this.generaData3 = arr
      var arr4 = []
      this.generaData3.forEach((item) => {
        item.child.forEach((ite) => {
          arr4.push({
            Name: ite.Name,
            parent: item.Name,
            checked: false
          })
        })
      })
      this.allProject3 = arr4
      var arr3 = []
      // 遍历项目楼栋中的小类
      this.filtrate.BuildingAreas.forEach((item) => {
        arr3.push({
          Name: item.Name,
          checked: false,
          parent: item.Name,
          child: item.Floors
        })
      })
      this.districtData3 = arr3
      var arr1 = []
      // 遍历项目楼栋中的小类
      this.districtData3.forEach((item) => {
        item.child.forEach((ite) => {
          arr1.push({
            Name: ite.Name,
            parent: item.Name,
            child: ite.Rooms,
            checked: false
          })
        })
      })
      this.floorData3 = arr1
      var arr2 = []
      // 遍历项目楼栋中的小类
      this.floorData3.forEach((item) => {
        item.child.forEach((ite) => {
          arr2.push({
            parent: item.parent,
            Name: ite,
            parent1: item.Name,
            checked: false
          })
        })
      })
      this.roomData3 = arr2
      var arr3 = []
      // 遍历项目楼栋中的小类
      this.filtrate.Records.forEach((item) => {
        arr3.push({
          parent: item,
          Name: item,
          checked: false
        })
      })
      this.recordData3 = arr3
    },

    showContent(event) {
      this.active = event
      this.drawer = false
    },

    // 显示右侧功能列表
    hideDrawer() {
      this.$emit('closewin', this.items)
    },
    //显示添加说明弹窗
    showExplain(item) {
      this.items = item
      this.dialogExplain = true
    },
    // 说明点击确定
    upExplain(e) {
      var newList = this.historyData
      newList.forEach((item) => {
        if (item.Id == e.Id) {
          item.Remark = e.Remark
        }
      })
      this.historyData = newList
      this.dialogExplain = false
    },
    // 说明点击关闭
    closeExplainBox(flag) {
      this.dialogExplain = flag
    },

    //显示未完成时弹窗
    showUnfinished(item) {
      this.items = item
      this.status = item.Value ? item.Value : 4
      this.dialogUnfinished = true
    },
    // 未完成弹窗点击确定
    upData(e) {
      var newList = this.obj.Items
      newList.forEach((item) => {
        if (item.Id == e.Id) {
          item.Remark = e.Remark
          item.Value = e.Value
          item.IsEdit = 1
        }
      })
      this.obj.Items = newList
      this.dialogUnfinished = false
    },
    // 关闭未完成时弹窗
    closeWindow(e) {
      var newList = this.obj.Items
      newList.forEach((item) => {
        if (item.Id == e.Id) {
          item.Value = null
          item.Remark = null
          item.IsEdit = 0
        }
      })
      this.obj.Items = newList
      this.dialogUnfinished = false
    },

    // 点击显示成功弹窗
    showFinish(items, type) {
      this.items = items
      if (type == 'add') {
        this.items.CDate = this.dateFormats(true)
        this.input = ''
      } else {
        this.input = items.Value
      }
      this.dialogFinished = true
    },

    // 关闭完成时
    closeFinish(e) {
      this.dialogFinished = false
    },
    // 完成时弹窗点击确定
    winData(e) {
      var newList = this.historyData
      newList.forEach((item) => {
        if (item.Id == e.Id) {
          item.Remark = e.Remark
          item.IsEdit = 1
          item.Value = e.Value
        }
      })
      this.historyData = newList
      this.dialogFinished = false
    },

    // 显示历史记录
    showHistory(item) {
      this.items = item
      this.dialogTableVisible = true
    },
    // 关闭历史
    closeHis() {
      this.dialogTableVisible = false
    },

    // 保存同步数据
    saveData() {
      this.historyData.forEach((item) => {
        if (item.Value && item.CDate) item.IsEdit = 1
      })
      this.$confirm('是否确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var member = JSON.parse(localStorage.getItem('user'))
          this.loading = true
          var that = this
          var obj = that.historyData
            .filter((item) => item.IsEdit == 1)
            .map((val) => {
              return {
                CDate: val.CDate,
                Remark: val.Remark,
                VitalId: val.VitalId,
                ProfileId: val.ProfileId,
                Value: val.Value,
                IsEdit: 1
              }
            })
          if (obj.length == 0) {
            this.$message.error({
              message: '请填写记录数值',
              offset: 100
            })
          } else {
            var objs = {
              Records: obj
            }

            this.$axios
              .post('/Pad/SaveVitalSigns?cUser=' + member.UserName + '&cUserId=' + member.UserId, objs)
              .then((response) => {
                if (response.data.ok) {
                  that.historyData = []
                  that.$message({
                    message: '提交成功',
                    offset: 100,
                    type: 'success'
                  })
                } else {
                  that.$message.error({
                    message: response.data.msg || '出错了，请稍后重试',
                    offset: 100
                  })
                }
              })
              .catch((err) => {
                // 没有报错提示保存到本地
                if (!err) localStorage.setItem('lifeRecord', JSON.stringify(objs))
              })
          }
        })
        .catch(() => {})
    },
    //判断时间是否大于当前时间
    filterTime1(endTime, nowTime) {
      var stre = endTime.split(':')
      if (stre.length != 2) {
        return false
      }
      var strn = nowTime.split(':')
      if (stre.length != 2) {
        return false
      }
      var e = new Date()
      var n = new Date()
      e.setHours(stre[0])
      e.setMinutes(stre[1])
      n.setHours(strn[0])
      n.setMinutes(strn[1])
      if (n.getTime() >= e.getTime()) {
        return true
      } else {
        return false
      }
    },

    // 历史记录筛选点击
    BuildingAreas2(code, val) {
      if (val.checked) {
        val.checked = false
        if (code == 0) {
          this.llist2 = this.llist2.filter((item) => {
            return item != val.Name
          })
        } else if (code == 1) {
          this.clist2 = this.clist2.filter((item) => {
            return item != val.Name
          })
        } else if (code == 2) {
          this.croom2 = this.croom2.filter((item) => {
            return item != val.Name
          })
          this.allRoomsChecked2()
        } else if (code == 3) {
          this.crecord = this.crecord.filter((item) => {
            return item != val.parent
          })
          this.allRecordChecked()
        }
      } else {
        val.checked = true
        if (code == 0) {
          this.llist2.push(val.Name)
        } else if (code == 1) {
          this.clist2.push(val.Name)
        } else if (code == 2) {
          this.croom2.push(val.Name)
          this.allRoomsChecked2()
        } else if (code == 3) {
          this.crecord.push(val.parent)
          this.allRecordChecked()
        }
      }
      this.currentPage2 = 1
    },

    //历史记录房间全选
    allRooms2() {
      this.allroom2 = !this.allroom2
      if (this.allroom2) {
        this.roomList2.forEach((item) => {
          item.checked = true
          this.croom2.push(item.Name)
        })
      } else {
        this.roomList2.forEach((item) => {
          item.checked = false
          this.croom2 = []
        })
      }
    },
    allRoomsChecked2() {
      if (this.croom2.length == this.roomList2.length) {
        this.allroom2 = true
      } else {
        this.allroom2 = false
      }
    },
    //记录全选
    allRecord() {
      this.allrecord = !this.allrecord
      if (this.allrecord) {
        this.recordList.forEach((item) => {
          item.checked = true
          this.crecord.push(item.Name)
        })
      } else {
        this.recordList.forEach((item) => {
          item.checked = false
          this.crecord = []
        })
      }
    },
    allRecordChecked() {
      if (this.crecord.length == this.recordList.length) {
        this.allrecord = true
      } else {
        this.allrecord = false
      }
    },

    // 历史记录筛选点击
    BuildingAreas3(code, val) {
      if (val.checked) {
        val.checked = false
        if (code == 0) {
          this.llist3 = this.llist3.filter((item) => {
            return item != val.Name
          })
        } else if (code == 1) {
          this.clist3 = this.clist3.filter((item) => {
            return item != val.Name
          })
        } else if (code == 2) {
          this.croom3 = this.croom3.filter((item) => {
            return item != val.Name
          })
          this.allRoomsChecked3()
        } else if (code == 3) {
          this.crecord3 = this.crecord3.filter((item) => {
            return item != val.parent
          })
          this.allRecordChecked3()
        }
      } else {
        val.checked = true
        if (code == 0) {
          this.llist3.push(val.Name)
        } else if (code == 1) {
          this.clist3.push(val.Name)
        } else if (code == 2) {
          this.croom3.push(val.Name)
          this.allRoomsChecked3()
        } else if (code == 3) {
          this.crecord3.push(val.parent)
          this.allRecordChecked3()
        }
      }
      this.currentPage3 = 1
    },

    //历史记录房间全选
    allRooms3() {
      this.allroom3 = !this.allroom3
      if (this.allroom3) {
        this.roomList3.forEach((item) => {
          item.checked = true
          this.croom3.push(item.Name)
        })
      } else {
        this.roomList3.forEach((item) => {
          item.checked = false
          this.croom3 = []
        })
      }
    },
    allRoomsChecked3() {
      if (this.croom3.length == this.roomList3.length) {
        this.allroom3 = true
      } else {
        this.allroom3 = false
      }
    },
    //记录全选
    allRecord3() {
      this.allrecord3 = !this.allrecord3
      if (this.allrecord3) {
        this.recordList3.forEach((item) => {
          item.checked = true
          this.crecord3.push(item.Name)
        })
      } else {
        this.recordList3.forEach((item) => {
          item.checked = false
          this.crecord3 = []
        })
      }
    },
    allRecordChecked3() {
      if (this.crecord3.length == this.recordList3.length) {
        this.allrecord3 = true
      } else {
        this.allrecord3 = false
      }
    },

    closebox() {
      this.dialogFinished = false
      this.dialogUnfinished = false
      this.dialogTableVisible = false
      this.dialogExplain = false
    },
    // 限制输入的最大最小值
    handleInput(data) {
      console.log(Number(data.Value) !== NaN)
      if (!data.Value && Number(data.Value) !== NaN) return false
      const value = Number(data.Value)
      const max = Number(data.MaxValue)
      const min = Number(data.MinValue)
      if (data.MaxValue) {
        if (max < value) data.Value = ''
        this.$message.error({
          message: '输入值超出合理范围',
          offset: 100
        })
      }
      if (data.MinValue) {
        if (min > value) data.Value = ''
        this.$message.error({
          message: '输入值超出合理范围',
          offset: 100
        })
      }
    },
    // 搜索历史数据
    searchHistory() {
      this.loadings = true
      var rooms = this.croom2.join(',')
      var records = this.crecord.join(',')
      if (!rooms || !records) {
        this.$message.error({
          message: '请选择房间和记录',
          offset: 100
        })
        return
      }
      this.$axios
        .post('/Pad/GetVitalSigns?rooms=' + rooms + '&records=' + records)
        .then((response) => {
          if (response.data.ok) {
            this.historyData = response.data.obj.Records
            this.historyData.forEach((item) => {
              item.CDate = this.dateFormats(true)
            })
            this.loadings = false
          } else {
            this.loadings = false
            if (response.data.msg == '参数错误') {
              this.$message.error({
                message: '请选择房间和记录',
                offset: 100
              })
            } else {
              this.$message.error({
                message: response.data.msg,
                offset: 100
              })
            }
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // 搜索历史数据
    searchHistoryList() {
      this.loadings = true
      var objs = {
        begin: this.begin,
        end: this.end,
        rooms: this.croom3,
        careItems: this.crecord3
      }
      this.$axios.post('/Pad/GetVitalSignsHistory', objs).then((response) => {
        if (response.data.ok) {
          this.historyList = response.data.obj
          this.loadings = false
        } else {
          this.loadings = false
          if (response.data.msg == '参数错误') {
            this.$message.error({
              message: '请选择房间和记录',
              offset: 100
            })
          } else {
            this.$message.error({
              message: response.data.msg,
              offset: 100
            })
          }
        }
      })
    },
    // 退出登录
    rightClick(val) {
      switch (val) {
        case 6:
          this.$confirm('确定退出吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              sessionStorage.removeItem('token')
              /*window.location.href = "@Url.Action("Login")?grpid=@ViewBag.grpid&comId=@ViewBag.comId"*/
            })
            .catch(() => {})
          break
        default:
          this.page = val
          break
      }
    },

    // 筛选时间的方法
    filterTime(beginTime, endTime, nowTime) {
      var strb = beginTime.split(':')
      if (strb.length != 2) {
        return false
      }

      var stre = endTime.split(':')
      if (stre.length != 2) {
        return false
      }
      var strn = nowTime.split(':')
      if (stre.length != 2) {
        return false
      }
      var b = new Date()
      var e = new Date()
      var n = new Date()
      b.setHours(strb[0])
      b.setMinutes(strb[1])
      e.setHours(stre[0])
      e.setMinutes(stre[1])
      n.setHours(strn[0])
      n.setMinutes(strn[1])
      if (b.getTime() > e.getTime()) {
        //跨24小时
        if (n.getTime() > b.getTime() || n.getTime() < e.getTime()) {
          return true
        }
      }
      if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() <= 0) {
        //   在范围内
        return true
      } else {
        // 不在范围内
        return false
      }
    },
    func(time1, time2, time3) {
      var time = Date.parse(new Date(time3))
      var date1 = Date.parse(new Date(time1))
      var date2 = Date.parse(new Date(time2))
      if (date1 <= time && date2 >= time) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/theme/index.css';
@import '../../assets/css/reset.css';
@import '../../assets/css/index.css';
</style>
<style>
.el-collapse-item__header {
  background: transparent !important;
  border: 0 !important;
  height: 0.96rem !important;
  line-height: 0.96rem !important;
  color: #fefefe !important;
}
.filtrate-content .el-collapse-item__wrap {
  background-color: transparent;
  border: 0;
}
.el-message-box {
  width: 8.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Physicalrecord/index.vue